import theme from '../../base';

const collapse = {
  bg: theme.colors.neutrals.white,
  border: theme.colors.neutrals.gray200,
  foreground: theme.colors.neutrals.gray700,
  header: {
    bg: theme.colors.neutrals.gray200,
    foreground: theme.colors.neutrals.gray800,
    icon: theme.colors.neutrals.gray800,
  },
};

export default collapse;
